import axios from 'axios'

import { API_URL } from '../common/config'

const instance = axios.create({
  baseURL: `${API_URL}`,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 429) {
      error.response.data.message = 'Please wait before retrying'
    }

    return Promise.reject(error)
  }
)
export default instance
